<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ getTitle() | translate }}</h3>
    </div>
  </div>
  <div
    class="card-body d-flex justify-content-center align-items-stretch scroll my-5"
    [perfectScrollbar]="{ wheelPropagation: false }"
  >
    <form [formGroup]="form" class="form form-group w-100">
      <mat-form-field appearance="fill" class="w-100 mb-4">
        <mat-label>{{ 'NOTIFICATION.NAME' | translate }}</mat-label>
        <input matInput formControlName="name" rows="5" required />
        <mat-error *ngIf="isInvalid('name')">{{ getErrorMessage('Name') }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-100 mb-4">
        <mat-label>{{ 'NOTIFICATION.DESCRIPTION' | translate }}</mat-label>
        <textarea matInput formControlName="description" rows="5" required></textarea>
        <mat-error *ngIf="isInvalid('description')">{{ getErrorMessage('Description') }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-100 mb-4">
        <mat-label>{{ 'NOTIFICATION.TEMPLATE' | translate }}</mat-label>
        <textarea matInput formControlName="template" rows="5" required></textarea>
        <mat-error *ngIf="isInvalid('template')">{{ getErrorMessage('Template') }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-100 mb-4">
        <mat-label>{{ 'NOTIFICATION.COMPANY' | translate }}</mat-label>
        <mat-select formControlName="companyId" (focus)="getCompanies()">
          <div *ngIf="companies.length; then companyOptions; else loadingCompanies"></div>
          <ng-template #loadingCompanies>
            <mat-option value="">
              <mat-spinner diameter="20"></mat-spinner>
            </mat-option>
          </ng-template>
          <ng-template #companyOptions>
            <mat-option value=""></mat-option>
            <mat-option *ngFor="let company of companies" [value]="company.id">{{
              company.name
            }}</mat-option>
          </ng-template>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-100 mb-4">
        <mat-label>{{ 'NOTIFICATION.TRIGGER' | translate }}</mat-label>
        <mat-select formControlName="trigger" required>
          <mat-option *ngFor="let trigger of triggers" [value]="trigger">{{ trigger }}</mat-option>
        </mat-select>
        <mat-error *ngIf="isInvalid('trigger')">{{ getErrorMessage('Trigger') }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-100 mb-4">
        <mat-label>{{ 'NOTIFICATION.SOURCE' | translate }}</mat-label>
        <mat-select formControlName="source" required>
          <mat-option *ngFor="let source of sources" [value]="source">{{ source }}</mat-option>
        </mat-select>
        <mat-error *ngIf="isInvalid('source')">{{ getErrorMessage('Source') }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-100 mb-4">
        <mat-label>{{ 'NOTIFICATION.SCOPE' | translate }}</mat-label>
        <mat-select formControlName="scope" required>
          <mat-option *ngFor="let scope of scopes" [value]="scope">{{ scope }}</mat-option>
        </mat-select>
        <mat-error *ngIf="isInvalid('scope')">{{ getErrorMessage('Scope') }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-100 mb-4">
        <mat-label>{{ 'NOTIFICATION.TARGET' | translate }}</mat-label>
        <mat-select formControlName="target" required>
          <mat-option *ngFor="let target of targets" [value]="target">{{ target }}</mat-option>
        </mat-select>
        <mat-error *ngIf="isInvalid('target')">{{ getErrorMessage('Target') }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-100 mb-4">
        <mat-label>{{ 'NOTIFICATION.CATEGORY' | translate }}</mat-label>
        <input
          matInput
          formControlName="category"
          [matAutocomplete]="categoryAutocomplete"
          required
        />
        <mat-autocomplete #categoryAutocomplete="matAutocomplete" [displayWith]="display">
          <div *ngIf="isLoadingCategories; then loadingCategories; else categoryOptions"></div>
          <ng-template #loadingCategories>
            <mat-option value="">
              <mat-spinner diameter="20"></mat-spinner>
            </mat-option>
          </ng-template>
          <ng-template #categoryOptions>
            <mat-option *ngFor="let category of filteredCategories$ | async" [value]="category">{{
              category.name
            }}</mat-option>
          </ng-template>
        </mat-autocomplete>
        <mat-error *ngIf="isInvalid('category')">{{ getErrorMessage('Category') }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-100 mb-4">
        <mat-label>{{ 'NOTIFICATION.CHANNELS' | translate }}</mat-label>
        <mat-chip-list #chipList formControlName="channels" required>
          <mat-chip
            *ngFor="let channel of form.get('channels').value"
            (removed)="removeChannel(channel)"
          >
            {{ channel.name }}
            <button
              mat-icon-button
              matChipRemove
              style="width: 28px; height: 28px"
              class="d-flex align-items-center justify-content-center"
            >
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
          <input
            #search
            formControlName="channelSearch"
            [matAutocomplete]="channelAutocomplete"
            [matChipInputFor]="chipList"
            (focus)="getChannels($event)"
            (blur)="clearSearch($event)"
          />
        </mat-chip-list>
        <mat-autocomplete
          #channelAutocomplete="matAutocomplete"
          [displayWith]="display"
          (optionSelected)="selectChannel($event)"
        >
          <div *ngIf="channels.length; then channelOptions; else loadingChannels"></div>
          <ng-template #loadingChannels>
            <mat-option value="">
              <mat-spinner diameter="20"></mat-spinner>
            </mat-option>
          </ng-template>
          <ng-template #channelOptions>
            <mat-option *ngFor="let channel of filteredChannels$ | async" [value]="channel">{{
              channel.name
            }}</mat-option>
          </ng-template>
        </mat-autocomplete>
        <mat-error *ngIf="isInvalid('channels')">{{ getErrorMessage('Channels') }}</mat-error>
      </mat-form-field>
    </form>
  </div>
  <div class="card-footer d-flex justify-content-end">
    <button
      type="button"
      mat-raised-button
      cdkFocusInitial
      style="width: 75px"
      (click)="close($event)"
    >
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button
      type="button"
      mat-raised-button
      color="primary"
      style="width: 75px; margin-left: 10px"
      [disabled]="form.invalid"
      (click)="submit($event)"
    >
      {{ 'GLOBAL.SAVE' | translate }}
    </button>
  </div>
</div>
